var _path, _path2, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H175L200 25V200H0V0Z",
    fill: "#FF4E2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.6821 15H25.3076V21.8479H56.6821V15ZM26.288 15.9783V20.8696L26.2883 20.8696V15.9783L55.7016 15.9783H26.288ZM58.1571 79.5651H65.5105V30.6517L55.706 25.7604H55.7068L65.5113 30.6517V79.5651H58.1579L70.4136 104.022H65.5113L70.4128 104.022L58.1571 79.5651ZM18.939 99.1304L16.4878 104.022L11.5864 104.022H16.4887L18.9398 99.1304L63.0594 99.1304H18.939ZM21.3901 33.6843L27.4689 30.6517H54.5294L54.5295 30.6517H27.4697L21.3909 33.6844V50.2171H21.3901V33.6843ZM21.3901 74.6737V55.1084H60.6082V55.1084H21.3909V74.6737H21.3901ZM26.2924 84.4564L28.7435 79.5651H53.2548L28.7443 79.5651L26.2932 84.4564L26.2924 84.4564ZM21.3901 94.2391L23.8412 89.3477H58.1571L23.8421 89.3478L21.3909 94.2391L21.3901 94.2391ZM15.5082 80.5434H22.2557L10 105H17.0946L19.5457 100.109H62.4543L64.9054 105H72L59.7443 80.5434H66.4918V30.0471L55.9383 24.7821H26.0617L15.5082 30.0471V80.5434ZM22.3714 49.2388V34.289L27.7012 31.63H54.2988L59.6286 34.289V49.2388H22.3714ZM22.3714 73.6955V56.0867H59.6286V73.6955H22.3714ZM52.6497 80.5434L54.1204 83.4782H27.8796L29.3503 80.5434H52.6497ZM57.552 90.326L59.0227 93.2608H22.9773L24.448 90.326H57.552ZM26.2883 64.892V69.7833L26.288 69.7833V64.892H31.1903L26.2883 64.892ZM32.1707 63.9137H25.3076V70.7616H32.1707V63.9137ZM50.8039 64.892V69.7833L50.8036 69.7833V64.892H55.7059L50.8039 64.892ZM56.6863 63.9137H49.8232V70.7616H56.6863V63.9137Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 15,
    width: 6,
    height: 90,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 15,
    width: 6,
    height: 90,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadManager);
export default __webpack_public_path__ + "static/media/load_manager.ec2d9811db5cf9d9414a7b8938e03ec1.svg";
export { ForwardRef as ReactComponent };